(() => {
  const initHalloweenSection = (section) => {
    if (!section || section.dataset.halloweenReady === 'true') return;
    section.dataset.halloweenReady = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = section.querySelectorAll('.halloween-reveal');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
      );

      revealItems.forEach((item) => observer.observe(item));
    }

    if (!reduceMotion) {
      const parallaxItem = section.querySelector('[data-halloween-parallax]');
      const hero = section.querySelector('.halloween__hero');

      if (parallaxItem && hero) {
        hero.addEventListener('pointermove', (event) => {
          const bounds = hero.getBoundingClientRect();
          const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 12;
          const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 10;
          parallaxItem.style.setProperty('--parallax-x', x.toFixed(2));
          parallaxItem.style.setProperty('--parallax-y', y.toFixed(2));
        });

        hero.addEventListener('pointerleave', () => {
          parallaxItem.style.setProperty('--parallax-x', '0');
          parallaxItem.style.setProperty('--parallax-y', '0');
        });
      }

      const flyingGhost = section.querySelector('[data-halloween-flying-ghost]');
      if (flyingGhost && window.matchMedia('(pointer: fine)').matches) {
        section.addEventListener('pointermove', (event) => {
          const ghostWidth = flyingGhost.offsetWidth || 58;
          const placeOnLeft = event.clientX > window.innerWidth - 160;
          const placeBelow = event.clientY < 100;
          const offsetX = placeOnLeft ? -(ghostWidth + 76) : 76;
          const offsetY = placeBelow ? 62 : -54;
          const targetX = Math.max(10, Math.min(window.innerWidth - ghostWidth - 10, event.clientX + offsetX));
          const targetY = Math.max(10, Math.min(window.innerHeight - ghostWidth - 18, event.clientY + offsetY));
          const tilt = Math.max(-12, Math.min(12, event.movementX * 0.65));

          flyingGhost.style.setProperty('--ghost-x', `${targetX}px`);
          flyingGhost.style.setProperty('--ghost-y', `${targetY}px`);
          flyingGhost.style.setProperty('--ghost-tilt', `${tilt}deg`);
          flyingGhost.classList.add('is-chasing');
        });

        section.addEventListener('pointerleave', () => {
          flyingGhost.classList.remove('is-chasing');
        });
      }
    }
  };

  const initAllHalloweenSections = (root = document) => {
    root.querySelectorAll('[data-halloween-section]').forEach(initHalloweenSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllHalloweenSections());
  } else {
    initAllHalloweenSections();
  }

  document.addEventListener('shopify:section:load', (event) => initAllHalloweenSections(event.target));
})();
